import {
  deviceCheck,
  getSessionStorage,
  IconButton,
  parseStringToBoolean,
  setSessionStorage,
} from '@healthhub/react-ui';
import { useState } from 'react';

import { FilledHealthHubIcon, OutlinedCloseIcon } from '@shared/assets-icon';
import { envBaseUrl } from '@shared/configs/configs/config';
import { DEEP_LINKS } from '@shared/constants/deepLinks';
import { SESSION_KEY } from '@shared/constants/sessionKey';

const SmartBanner = () => {
  const smartBannerDismissed = getSessionStorage(SESSION_KEY.smartBannerDismissed) ?? '';
  const isSmartBannerDismissed = parseStringToBoolean(smartBannerDismissed);
  const [isDismissed, setIsDismissed] = useState(isSmartBannerDismissed);

  const onClickDismiss = () => {
    setIsDismissed(true);
    setSessionStorage(SESSION_KEY.smartBannerDismissed, true.toString());
  };

  const onClickOpen = () => {
    window.location.href = `${envBaseUrl()}${DEEP_LINKS.openApp}`;
  };

  if (isDismissed || deviceCheck.isDesktop()) return null;

  return (
    <div className="flex justify-between h-18 p-3 bg-functional-haze drop-shadow-smart-banner" role="banner">
      <div className="flex gap-3">
        <div className="flex gap-1">
          <IconButton
            aria-label="Dismiss app banner"
            className="self-start"
            icon={<OutlinedCloseIcon className="size-6" />}
            onClick={onClickDismiss}
          />
          <FilledHealthHubIcon className="shrink-0 size-12" />
        </div>
        <div className="flex flex-col gap-1">
          <h4 className="h4 font-bold">HealthHub</h4>
          <span className="caption">Your health - simplified.</span>
        </div>
      </div>
      <button
        className="leading-tight bg-primary-blue-grey-3 h-12 px-4 py-3.5 text-white rounded-lg font-semibold text-base"
        onClick={onClickOpen}
      >
        Open
      </button>
    </div>
  );
};

export default SmartBanner;
